export const getAspectos = (state) => state.aspectos.lista
export const getIsCarregandoListaAspectos = (state) => state.aspectos.isCarregandoLista
export const getIsUpdatingAspectos = (state) => state.aspectos.isUpdate
